export default {
  WEBLOYALTY_DEFAULT: 'WEBLOYALTY_DEFAULT',
  WEBLOYALTY_MATCH: 'WEBLOYALTY_MATCH',
};
